// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"fe247ccd","339":"d7064048","374":"14ca41bf","958":"a5c2978f"}[chunkId] + ".chunk.js";
};